module.exports = __webpack_public_path__ + "img/7c2df8b.jpg";